import { Injectable } from '@angular/core';
import { loadPhoneNumberRules } from './phone-number-rules.loader';

@Injectable({
  providedIn: 'root',
})
export class PhoneNumberService {
  /**
   * 验证手机号码是否合格
   *
   * 規則表改為動態載入（見 {@link loadPhoneNumberRules}），因此本方法為非同步。
   * 呼叫端需 `await`。
   *
   * @param phone 手机号码
   * @param areaCode 区号
   */
  public async checkVaild(phone: string, areaCode: string): Promise<boolean> {
    const rules = await loadPhoneNumberRules();

    return rules.checkPhoneValid(phone, areaCode);
  }
}
